import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';

const SkdrRoutes = [
  <Route path="/skdr/job/:jobCat" element={<EntityView />} />,
  <Route path="/skdr/job" element={<EntityView />} />,
  <Route path="/skdr/queued-job" element={<EntityView />} />,
  <Route path="/skdr/run" element={<EntityView />} />,
  <Route path="/skdr/sched" element={<EntityView />} />,
  <Route path="/skdr/event" element={<EntityView />} />,
  <Route path="/skdr/event/pending-approvals" element={<EntityView />} />,
];

export default SkdrRoutes;
